import { render } from "./QuickAccessItem.vue?vue&type=template&id=06e49681"
import script from "./QuickAccessItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAccessItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Common/Helpers/QuickAccessItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06e49681"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06e49681', __exports__)) {
    api.reload('06e49681', __exports__)
  }
  
  module.hot.accept("./QuickAccessItem.vue?vue&type=template&id=06e49681", () => {
    api.rerender('06e49681', render)
  })

}


export default __exports__